import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

import { translate } from 'services/i18nService';
import GiftsStore from 'stores/GiftsStore';
import TabPanel from 'pages/ProfileV2/ProfileV2Desktop/Broadcast/Chat/ChatTabs/TabPanel';

import FeaturedGifts from '../FeaturedGifts';
import PopularGifts from '../PopularGifts';
import GoldGifts from '../GoldGifts/GoldGifts';

import styles from './GiftTabs.css';


function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const GiftTabs = ({ onGiftClickHandler, upgradeToGold, isGoldSelected, isDesktop }) => {
  const { quickGiftsData } = GiftsStore;

  const featuredCategory = quickGiftsData?.featured?.[0] || [];
  const popularGifts = quickGiftsData?.popular || [];
  const goldGifts = quickGiftsData?.gold || [];

  let featuredLabel = 'Featured';
  if (quickGiftsData) {
    featuredLabel = translate(
      `gifting.${featuredCategory.ttKey}`,
      {},
      featuredCategory.name
    );
  }

  const placeholderWrapperClass = classNames({
    [styles.placeholderWrapper]: isDesktop,
    [styles.placeholderWrapperMobile]: !isDesktop,
  });

  const placeholders = [...Array(6)].map((_, i) => (
    <div key={i} className={placeholderWrapperClass}>
      <div className={styles.placeholder} />
    </div>
  ));

  const [tabValue, setTabValue] = React.useState(isGoldSelected ? 2 : 0);

  const onChangeTab = useCallback((event, newValue) => {
    setTabValue(newValue);
  }, []);

  return (
    <Fragment>
      <AppBar classes={{ root: styles.tabContainer }} position="static">
        <Tabs
          centered={true}
          classes={{ indicator: styles.indicator }}
          value={tabValue}
          onChange={onChangeTab}
        >
          <Tab
            classes={{ root: styles.tab }}
            label={featuredLabel}
            wrapped={true}
            {...a11yProps(0)}
          />
          <Tab
            classes={{ root: styles.tab }}
            label={translate('gifting.profile.gift.popular')}
            {...a11yProps(1)}
          />
          <Tab
            classes={{ root: styles.tab }}
            label={translate('v2profile.gifting.gold.gift')}
            {...a11yProps(2)}
          />
        </Tabs>
      </AppBar>
      <TabPanel index={0} value={tabValue}>
        <div className={styles.featuredGiftsContainer}>
          {featuredCategory.gifts ? (
            <FeaturedGifts
              gifts={featuredCategory.gifts}
              isDesktop={isDesktop}
              onClickHandler={onGiftClickHandler}
            />
          ) : (
            placeholders
          )}
        </div>
      </TabPanel>
      <TabPanel index={1} value={tabValue}>
        <div className={styles.popularGiftsContainer}>
          <PopularGifts
            gifts={popularGifts}
            isDesktop={isDesktop}
            onClickHandler={onGiftClickHandler}
          />
        </div>
      </TabPanel>
      <TabPanel index={2} value={tabValue}>
        <div>
          <GoldGifts {...goldGifts} upgradeToGold={upgradeToGold} />
        </div>
      </TabPanel>
    </Fragment>
  );
};

GiftTabs.propTypes = {
  upgradeToGold: PropTypes.func.isRequired,
  onGiftClickHandler: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool,
  isGoldSelected: PropTypes.bool,
};

GiftTabs.defaultProps = {
  isDesktop: false,
  isGoldSelected: false,
};

export default observer(GiftTabs);
